module.exports = __webpack_public_path__ + "static/media/breakfast-cooking-egg-svgrepo-com.2eb2a63a.svg";